module.exports = __webpack_public_path__ + "static/media/animal_07.ec040b7c.png";